<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { mdiArrowLeft } from '@mdi/js'
import { UserService } from '@/services/user-service'
import { Settings } from '@/settings'

const route = useRoute()
const router = useRouter()

const active = ref(false)
const showDrawer = computed(() => active.value && !route.meta.hideNav)

const toggle = () => {
	active.value = !active.value
}

const locationId = ref(parseInt(localStorage.getItem('LOCATION_ID')) || undefined)

const changeLocation = (id) => {
	localStorage.setItem('LOCATION_ID', id)
	locationId.value = id
	location.reload()
}

const logout = () => {
	UserService.logout()
	toggle()
	router.push({ name: 'login' })
}

const reload = () => {
	location.reload()
}

</script>

<template>
<v-app-bar
	v-show="!$route.meta.hideNav"
	:elevation="3"
	:color="Settings.APP_COLOR"
>
	<template #prepend>
		<v-app-bar-nav-icon
			v-if="route.meta.back"
			:icon="mdiArrowLeft"
			@click="router.push(route.meta.back(route))"
		/>
		<v-app-bar-nav-icon
			v-else
			color="white"
			@click="toggle"
		/>
	</template>
    
	<v-app-bar-title>Inspections</v-app-bar-title>

	<div
		id="app-bar-actions-target"
		class="d-flex app-bar"
	/>
</v-app-bar>

<v-navigation-drawer
	v-model="showDrawer"
>
	<v-list-item subtitle="Menu" />
	<v-divider />
	<v-list-item>
		<v-select
			:model-value="locationId"
			:items="[
				{ id: -1, name: 'Auto' },
				...Settings.LOCATIONS,
			]"
			item-title="name"
			item-value="id"
			label="Location"
			variant="solo"
			density="comfortable"
			hide-details
			class="my-2 mx-1"
			@update:model-value="changeLocation"
		/>
	</v-list-item>
	<v-divider />
	<v-list-item
		link
		title="Reload"
		@click="reload"
	/>
	<v-list-item
		link
		title="Sign out"
		@click="logout"
	/>
	<v-divider />
	<v-list-item
		link
		title="Network"
		@click="() => {
			router.push({ name: 'request-view' })
			toggle()
		}"
	/>
	<v-list-item
		link
		title="Event log"
		@click="() => {
			router.push({ name: 'log-view' })
			toggle()
		}"
	/>
</v-navigation-drawer>
</template>

<styles lang="scss" scoped>
$spacing: 12px;

.app-bar {
    gap: $spacing;
    padding: 0 $spacing;
}
</styles>